module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-expand ds-calendar-app"
  }, [_c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "app": "",
      "clipped": _vm.$vuetify.breakpoint.lgAndUp
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_vm._t("drawerTop"), _vm._v(" "), _vm._t("drawerPicker", [(_vm.calendar) ? _c('div', {
    staticClass: "pa-3"
  }, [_c('ds-day-picker', {
    attrs: {
      "span": _vm.calendar.span
    },
    on: {
      "picked": _vm.rebuild
    }
  })], 1) : _vm._e()], {
    calendar: _vm.calendar,
    picked: _vm.rebuild
  }), _vm._v(" "), _vm._t("drawerBottom")], 2), _vm._v(" "), _c('v-toolbar', {
    staticClass: "ds-app-calendar-toolbar",
    attrs: {
      "app": "",
      "flat": "",
      "fixed": "",
      "color": "white",
      "clipped-left": _vm.$vuetify.breakpoint.lgAndUp
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ml-0",
    style: (_vm.toolbarStyle)
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._t("title", null, {
    calendar: _vm.calendar
  })], 2)], 1), _vm._v(" "), _vm._t("today", [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "ds-skinny-button",
    attrs: {
      "slot": "activator",
      "depressed": "",
      "icon": _vm.$vuetify.breakpoint.smAndDown
    },
    on: {
      "click": _vm.setToday
    },
    slot: "activator"
  }, [(_vm.$vuetify.breakpoint.mdAndUp) ? _c('span', [_vm._v(_vm._s(_vm.labels.today))]) : _c('v-icon', [_vm._v(_vm._s(_vm.labels.todayIcon))])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.todayDate))])], 1)], null, {
    setToday: _vm.setToday,
    todayDate: _vm.todayDate,
    calendar: _vm.calendar
  }), _vm._v(" "), _vm._t("prev", [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "ds-light-forecolor ds-skinny-button",
    attrs: {
      "slot": "activator",
      "icon": "",
      "depressed": ""
    },
    on: {
      "click": _vm.prev
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.prevLabel))])], 1)], null, {
    prev: _vm.prev,
    prevLabel: _vm.prevLabel,
    calendar: _vm.calendar
  }), _vm._v(" "), _vm._t("next", [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "ds-light-forecolor ds-skinny-button",
    attrs: {
      "slot": "activator",
      "icon": "",
      "depressed": ""
    },
    on: {
      "click": _vm.next
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.nextLabel))])], 1)], null, {
    next: _vm.next,
    nextLabel: _vm.nextLabel,
    calendar: _vm.calendar
  }), _vm._v(" "), _vm._t("summary", [_c('h1', {
    staticClass: "title ds-light-forecolor"
  }, [_vm._v("\n        " + _vm._s(_vm.summary) + "\n      ")])], null, {
    summary: _vm.summary,
    calendar: _vm.calendar
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("view", [_c('v-menu', [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_vm._v("\n          " + _vm._s(_vm.currentType.label) + "\n          "), _c('v-icon', [_vm._v("arrow_drop_down")])], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.types), function(type) {
    return _c('v-list-tile', {
      key: type.id,
      on: {
        "click": function($event) {
          _vm.currentType = type
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(type.label))])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v(_vm._s(type.shortcut))])], 1)
  }))], 1)], null, {
    currentType: _vm.currentType,
    types: _vm.types
  }), _vm._v(" "), _vm._t("menuRight")], 2), _vm._v(" "), _c('v-content', {
    staticClass: "ds-expand"
  }, [_c('v-container', {
    staticClass: "ds-calendar-container",
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('ds-gestures', {
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev
    }
  }, [(_vm.currentType.schedule) ? _c('div', {
    staticClass: "ds-expand"
  }, [_vm._t("calendarAppAgenda", [_c('ds-agenda', _vm._g(_vm._b({
    attrs: {
      "read-only": _vm.readOnly,
      "calendar": _vm.calendar
    },
    on: {
      "add": _vm.add,
      "edit": _vm.edit,
      "view-day": _vm.viewDay
    }
  }, 'ds-agenda', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], null, {
    $scopedSlots: _vm.$scopedSlots,
    $listeners: _vm.$listeners,
    calendar: _vm.calendar,
    add: _vm.add,
    edit: _vm.edit,
    viewDay: _vm.viewDay
  })], 2) : _c('div', {
    staticClass: "ds-expand"
  }, [_vm._t("calendarAppCalendar", [_c('ds-calendar', _vm._g(_vm._b({
    ref: "calendar",
    attrs: {
      "calendar": _vm.calendar,
      "read-only": _vm.readOnly
    },
    on: {
      "add": _vm.add,
      "add-at": _vm.addAt,
      "edit": _vm.edit,
      "view-day": _vm.viewDay,
      "added": _vm.handleAdd,
      "moved": _vm.handleMove
    }
  }, 'ds-calendar', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], null, {
    $scopedSlots: _vm.$scopedSlots,
    $listeners: _vm.$listeners,
    calendar: _vm.calendar,
    add: _vm.add,
    addAt: _vm.addAt,
    edit: _vm.edit,
    viewDay: _vm.viewDay,
    handleAdd: _vm.handleAdd,
    handleMove: _vm.handleMove
  })], 2)]), _vm._v(" "), _vm._t("calendarAppEventDialog", [_c('ds-event-dialog', _vm._g(_vm._b({
    ref: "eventDialog",
    attrs: {
      "calendar": _vm.calendar,
      "read-only": _vm.readOnly
    },
    on: {
      "saved": _vm.eventFinish,
      "actioned": _vm.eventFinish
    }
  }, 'ds-event-dialog', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], null, {
    $scopedSlots: _vm.$scopedSlots,
    $listeners: _vm.$listeners,
    calendar: _vm.calendar,
    eventFinish: _vm.eventFinish
  }), _vm._v(" "), _vm._t("calendarAppOptions", [_c('v-dialog', _vm._b({
    ref: "optionsDialog",
    attrs: {
      "fullscreen": _vm.$dayspan.fullscreenDialogs
    },
    model: {
      value: (_vm.optionsVisible),
      callback: function($$v) {
        _vm.optionsVisible = $$v
      },
      expression: "optionsVisible"
    }
  }, 'v-dialog', _vm.optionsDialog, false), [_c('v-list', [_vm._l((_vm.options), function(option) {
    return [_c('v-list-tile', {
      key: option.text,
      on: {
        "click": function($event) {
          _vm.chooseOption(option)
        }
      }
    }, [_vm._v("\n                " + _vm._s(option.text) + "\n              ")])]
  })], 2)], 1)], null, {
    optionsVisible: _vm.optionsVisible,
    optionsDialog: _vm.optionsDialog,
    options: _vm.options,
    chooseOption: _vm.chooseOption
  }), _vm._v(" "), _vm._t("calendarAppPrompt", [_c('v-dialog', _vm._b({
    ref: "promptDialog",
    model: {
      value: (_vm.promptVisible),
      callback: function($$v) {
        _vm.promptVisible = $$v
      },
      expression: "promptVisible"
    }
  }, 'v-dialog', _vm.promptDialog, false), [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.promptQuestion))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.choosePrompt(true)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.labels.promptConfirm) + "\n              ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.choosePrompt(false)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.labels.promptCancel) + "\n              ")])], 1)], 1)], 1)], null, {
    promptVisible: _vm.promptVisible,
    promptDialog: _vm.promptDialog,
    promptQuestion: _vm.promptQuestion,
    choosePrompt: _vm.choosePrompt
  }), _vm._v(" "), _vm._t("calendarAppAdd", [(!_vm.readOnly) ? _c('v-fab-transition', [_c('v-btn', {
    staticClass: "ds-add-event-today",
    attrs: {
      "color": "primary",
      "fixed": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    on: {
      "click": _vm.addToday
    },
    model: {
      value: (_vm.allowsAddToday),
      callback: function($$v) {
        _vm.allowsAddToday = $$v
      },
      expression: "allowsAddToday"
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1) : _vm._e()], null, {
    allowsAddToday: _vm.allowsAddToday,
    addToday: _vm.addToday
  }), _vm._v(" "), _vm._t("containerInside", null, null, {
    events: _vm.events,
    calendar: _vm.calendar
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58feea2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CalendarApp.vue
// module id = 171
// module chunks = 0